import { useMutation } from '@tanstack/react-query';
import { POST } from '../../../../services';
import { openAlert } from '../../../../components/alert/useAlert';
import { InsertManagement } from '../main';

const POST_INSERT_MANAGEMENT = '/warranty/abm/api/v2/admin/options/map-products/insert';

export const useInsertManagement = () => {
  return useMutation({
    mutationFn: async (values) => {
      const payload = InsertManagement(values);
      const response = await POST(POST_INSERT_MANAGEMENT, payload);

      return response.result;
    },
    onSuccess: () => {
      openAlert({
        model: 'message',
        type: 'success',
        message: 'เพิ่ม Management สำเร็จ',
      });
    },
  });
};
